import React from "react";
import { Card, CardHeader, CardContent, Divider } from "@mui/material";

const AccessDenied = ({ activeTheme }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "94vh" }}>
      <Card sx={{ minWidth: "100%", height: "100%", textAlign: "center" }}>
        <CardHeader title="Access Denied" style={{ fontWeight: 600, fontSize: "1.6rem" }} />
        <Divider />
        <CardContent>
          <p>You do not have permission to access this page</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessDenied;